import React from "react";
import "./projects.css";
import { FaDharmachakra , FaAws,FaCss3Alt ,FaHtml5 , FaGithub, FaReact, FaJava, FaDocker } from 'react-icons/fa';
import { MdOutlineOpenInNew } from "react-icons/md";
import { SiTypescript, SiAmazons3 ,SiTerraform ,SiSpringboot  } from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io";

const technologyIcons = {
  React: <FaReact />,
  Java: <FaJava />,
  GitHub: <FaGithub />,
  Docker: <FaDocker />,
  Chakra: <FaDharmachakra />,
  TypeScript: <SiTypescript />,
  SpringBoot: <SiSpringboot />,
  HTML: <FaHtml5 />,
  CSS: <FaCss3Alt />,
  JavaScript: <IoLogoJavascript />,
  AmazonS3: <SiAmazons3 />,
  TerraForm: <SiTerraform />,
  AWS: <FaAws />,
};


const ProjectItems = ({ item }) => {
  return (
    <div className="projects-card">
      <img className="project-image" src={item.image} alt={item.title} />
      <h3>{item.title}</h3>
      {/* Remova a classe `home__social-icon` dos ícones de tecnologia */}
      <div className="TechnologiesIcons">
      {item.technologies &&
          item.technologies.map((tech, index) => (
            <span key={index}> {technologyIcons[tech]} </span>
          ))}
      </div>
      <div className="div_link">
        <a
          href={item.visualizar}
          target="_blank"
          rel="noopener noreferrer"
          className="button button--flex"
        >
          Visualizar
          <MdOutlineOpenInNew size={24} />
        </a>
        <a
          href={item.repositorio}
          target="_blank"
          rel="noopener noreferrer"
          className="button button--flex"
        >
          Repositório
          <FaGithub size={24} />
        </a>
      </div>
    </div>
  );
};

export default ProjectItems;